import { render } from "./labelsMenu.vue?vue&type=template&id=41874c6a"
import script from "./labelsMenu.vue?vue&type=script&lang=js"
export * from "./labelsMenu.vue?vue&type=script&lang=js"

import "./labelsMenu.vue?vue&type=style&index=0&id=41874c6a&lang=css"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__